import React, { useState, useEffect, useRef } from "react";
import { StaticRoutes } from "../routes";
import { useNavigate } from "react-router-dom";
import Nav from "../../components/Nav";
import { GetStartedHeader } from "../../components/GetStartedHeader/GetStartedHeader";
import { ProductItem } from "../../components/ProductItem/ProductItem";
import PricingOption from "../../components/PricingOption/PricingOption";
import { TestimonialSection } from "../../components/TestimonialSection/TestimonialSection";
import { ClientList } from "../../components/ClientList/ClientList";
import Footer from "../../components/Footer/Footer";
import AttentionModal from "../../components/Pricing/AttentionModal/AttentionModal";
import { AccountContainer } from "../../hooks/useAccount";
import styles from "../HomePage/HomePage.module.css";
import img from "../../assets/main.png";
import logo1 from "../../assets/BidProPlusBiddingLogo.png";
import logo2 from "../../assets/BidProPlusTripBoardLogo.png";
import logo3 from "../../assets/BidProPlusSeniorityLogo.png";
import image1 from "../../assets/new.png";
import image2 from "../../assets/rsz_11rsz_2imac-and-ipad.png";
import image3 from "../../assets/rsz_seniority-main.png";
import Loader from "../../components/Loader/Loader";

export const HomePage = ({
  navList = [
    {
      label: "HOME",
      options: [],
      border: false,
      path: StaticRoutes.Home,
    },
    {
      label: "PRODUCTS",
      options: [
        { label: "BIDDING", path: StaticRoutes.Bidding },
        { label: "TRIPBOARD", path: StaticRoutes.TripBoard },
        { label: "SENIORITY", path: StaticRoutes.Seniority },
      ],
      border: false,
    },
    {
      label: "PRICING",
      options: [
        { label: "UPS", path: StaticRoutes.UPSPricing },
        { label: "AMERICAN", path: StaticRoutes.Bidding },
        { label: "ALASKA", path: StaticRoutes.TripBoard },
        { label: "JETSUITE", path: StaticRoutes.Bidding },
      ],
      border: false,
    },
    {
      label: "CONTACT US",
      options: [],
      border: false,
      path: StaticRoutes.Contact,
    },
    /* {
      label: "LOG IN",
      options: [],
      border: false,
      path: StaticRoutes.Login,
    },*/
    {
      label: "SIGN UP",
      options: [
        { label: "UPS", path: StaticRoutes.UPSPricing },
        { label: "AMERICAN", path: StaticRoutes.Bidding },
        { label: "ALASKA", path: StaticRoutes.TripBoard },
        { label: "JETSUITE", path: StaticRoutes.Bidding },
      ],
      border: true,
    },
  ],
  getStartedHeaderList = [
    { label: "UPS", path: StaticRoutes.UPSPricing },
    { label: "AMERICAN", path: StaticRoutes.Bidding },
    { label: "ALASKA", path: StaticRoutes.TripBoard },
    { label: "JETSUITE", path: StaticRoutes.Bidding },
  ],
  footerLists = [
    {
      header: "MENU",
      links: [
        { name: "Home", src: StaticRoutes.Home },
        { name: "Contact Us", src: StaticRoutes.Contact },
        { name: "Sign Up", src: StaticRoutes.Home },
      ],
    },
    {
      header: "PRODUCTS",
      links: [
        { name: "Bidding", src: StaticRoutes.Bidding },
        { name: "Trip Board", src: StaticRoutes.TripBoard },
        { name: "Seniority", src: StaticRoutes.Seniority },
        { name: "Pricing", src: StaticRoutes.UPSPricing },
      ],
    },
    {
      header: "TECH SUPPORT",
      links: [
        { name: "tech@bidpro.com", src: "mailto:tech@bidpro.com" },
        { name: "1-800-918-4980", src: "tel:18009184980" },
      ],
    },
  ],
}) => {
  const [navScrolled, setNavScrolled] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { validateUser } = AccountContainer.useContainer();
  const [userValid, setUserValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [scrolled, setScrolled] = useState({
    product1: false,
    product2: false,
    product3: false,
    clientListHeader: false,
    clientListRow: false,
  });
  const product1Ref = useRef(null);
  const product2Ref = useRef(null);
  const product3Ref = useRef(null);
  const clientListHeaderRef = useRef(null);
  const clientListRowRef = useRef(null);
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    const handleScroll = () => {
      setNavScrolled(document.body.scrollTop > 700);
    };

    document.body.addEventListener("scroll", handleScroll);

    return () => {
      document.body.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const defaultObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setScrolled((prev) => ({
              ...prev,
              [entry.target.dataset.id]: true,
            }));
          }
        });
      },
      { threshold: 0.2 } // 20% visibility for most elements
    );

    const clientListObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setScrolled((prev) => ({
              ...prev,
              [entry.target.dataset.id]: true,
            }));
          }
        });
      },
      { threshold: 0.5 } // 50% visibility for ClientList
    );

    // Observe product sections with the default observer
    if (product1Ref.current) defaultObserver.observe(product1Ref.current);
    if (product2Ref.current) defaultObserver.observe(product2Ref.current);
    if (product3Ref.current) defaultObserver.observe(product3Ref.current);

    // Observe ClientList elements with the new observer
    if (clientListHeaderRef.current)
      clientListObserver.observe(clientListHeaderRef.current);
    if (clientListRowRef.current)
      clientListObserver.observe(clientListRowRef.current);

    return () => {
      defaultObserver.disconnect();
      clientListObserver.disconnect();
    };
  }, []);

  const pricingOptions = [
    {
      packageName: "BidPro Bundle",
      priceMonthly: "26.99",
      priceAnnual: "323.88",
      onMonthly: () => checkUser(),
      onAnnual: () => checkUser(),
      sections: [
        {
          section: {
            logo: "BidProPlusBiddingLogo.png",
            header: "",
            features: [],
          },
        },
        {
          section: {
            logo: "BidProPlusSeniorityLogo.png",
            header: "",
            features: [],
          },
        },
        {
          section: {
            logo: "BidProPlusTripBoardLogo.png",
            header: "Access to all the BidPro apps including:",
            features: [
              {
                feature: "Web-based Bidding",
                isNew: "",
              },
              {
                feature: "Seniority",
                isNew: "",
              },
              {
                feature: "Web-based TripBoard",
                isNew: "",
              },
              {
                feature: "iOS Mobile TripBoard",
                isNew: "NEW!*",
              },
            ],
          },
        },
      ],
      isBundle: true,
      savings: "10%",
      note: "Unlimited downloads for all your iOS devices included!",
    },
    {
      packageName: "Bidding & Seniority",
      priceMonthly: "9.99",
      priceAnnual: "119.88",
      onMonthly: () => checkUser(),
      onAnnual: () => checkUser(),
      sections: [
        {
          section: {
            logo: "BidProPlusBiddingLogo.png",
            header: "Bidding",
            features: [
              {
                feature: "Download bid packages",
                isNew: "",
              },
              {
                feature: "Customize bidline colors & sorts",
                isNew: "",
              },
              {
                feature: "Search & prepare bids offline",
                isNew: "",
              },
              {
                feature: "Submit bids directly and skip PBSI",
                isNew: "",
              },
            ],
          },
        },
        {
          section: {
            logo: "BidProPlusSeniorityLogo.png",
            header: "Seniority",
            features: [
              {
                feature: "View Seniority Ranking on a detailed graph",
                isNew: "",
              },
              {
                feature: "Compare rankings to other fleets",
                isNew: "",
              },
              {
                feature: "View yearly retires and estimate seniority",
                isNew: "",
              },
              {
                feature: "Use offline",
                isNew: "",
              },
            ],
          },
        },
      ],
      isBundle: false,
      savings: "",
      note: "",
    },
    {
      packageName: "TripBoard",
      priceMonthly: "19.99",
      priceAnnual: "239.88",
      onMonthly: () => checkUser(),
      onAnnual: () => checkUser(),
      sections: [
        {
          section: {
            logo: "BidProPlusTripBoardLogo.png",
            header: "Web-based TripBoard",
            features: [
              {
                feature: "View Schedule",
                isNew: "",
              },
              {
                feature: "Post & pick up trips",
                isNew: "",
              },
              {
                feature: "Receive trip notifications via text or email",
                isNew: "",
              },
              {
                feature: "View estimated pay & credit",
                isNew: "",
              },
            ],
          },
        },
        {
          section: {
            logo: "",
            header: "IOS Mobile TripBoard",
            features: [
              {
                feature: "View Schedule",
                isNew: "",
              },
              {
                feature: "Post & pick up trips",
                isNew: "",
              },
              {
                feature: "Receive trip notifications via text or email",
                isNew: "",
              },
              {
                feature: "Sync your schedule to your device",
                isNew: "NEW!",
              },
            ],
          },
        },
      ],
      isBundle: false,
      savings: "",
      note: "",
    },
  ];

  const navListWithNavigate = navList.map((item) => ({
    ...item,
    onClick: () => navigate(item.path),
    options: item.options?.map((option) => ({
      ...option,
      onClick: () => navigate(option.path),
    })),
  }));

  const getSHList = getStartedHeaderList.map((item) => ({
    ...item,
    onClick: () => navigate(item.path),
    options: item.options?.map((option) => ({
      ...option,
      onClick: () => navigate(option.path),
    })),
  }));

  const checkUser = async () => {
    try {
      setIsLoading(true);
      const result = await validateUser();

      if (!result) {
        setIsLoading(false);
        setUserValid(false);
        setIsModalOpen(true);
      }

      setUserValid(true);
      setIsModalOpen(false);
      navigate("/account");
      document.body.scrollTo(0, 0);
    } catch (error) {
      setUserValid(false);
      setIsModalOpen(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Nav
        isStatic={false}
        navItems={navListWithNavigate}
        scrolled={navScrolled}
      />
      <GetStartedHeader
        header={
          "BidPro Plus! dramatically improves your schedule and quality of life with powerful, innovative bidding solutions for airlines and crew members."
        }
        img={img}
        options={getSHList}
      />
      <div className={styles.ProductContainer}>
        <h1 className={styles.headingH1}>Our Products</h1>
        <div
          ref={product1Ref}
          data-id="product1"
          className={`${styles.product1} ${
            scrolled.product1 ? styles.animate : ""
          }`}
        >
          <ProductItem
            logo={logo1}
            description="Our easy-to-use, intuitive Bidding application allows crew members to view, sort and organize their bid lines to create the bids they really want."
            img={image1}
            color="#29abe2"
            onClick={() => {
              navigate(StaticRoutes.Bidding);
              // window.scrollTo(0, 0);
            }}
            hasFreeTrial={false}
          />
        </div>
        <div
          ref={product2Ref}
          data-id="product2"
          className={`${styles.product2} ${
            scrolled.product2 ? styles.animate : ""
          }`}
        >
          <ProductItem
            logo={logo2}
            description="Our Trip Board application provides the ability for crew members to view their schedules, view available trips, pick up extra trips, and post their unwanted trips for other pilots to pick up."
            img={image2}
            color="#22b573"
            onClick={() => {
              navigate(StaticRoutes.TripBoard);
              // window.scrollTo(0, 0);
            }}
            hasFreeTrial={false}
          />
        </div>
        <div
          ref={product3Ref}
          data-id="product3"
          className={`${styles.product3} ${
            scrolled.product3 ? styles.animate : ""
          }`}
        >
          <ProductItem
            logo={logo3}
            description="BidPro's newest app, that shows UPS pilot's dynamic seniority and provides advanced metrics on performance"
            img={image3}
            color="#e9b20d"
            onClick={() => {
              // window.scrollTo(0, 0);
              navigate(StaticRoutes.Seniority);
            }}
            hasFreeTrial={false}
          />
        </div>
      </div>
      <div className={`${styles.container} container`}>
        <h1>Pricing</h1>
        <p>Product availability and pricing varies by airline.</p>
        <p>
          To view {currentYear} subscription bundles by airline, select your
          airline from the dropdown menu under PRICING.
        </p>
        {isLoading ? (
          <div className={styles.loaderContainer}>
            <Loader color={"#3c4554"} size={75} />
          </div>
        ) : (
          <div className={styles.pricingOptionContainer}>
            {pricingOptions.map((option, index) => (
              <div key={index} className={styles.pricingOption}>
                <PricingOption
                  packageName={option.packageName}
                  priceMonthly={option.priceMonthly}
                  priceAnnual={option.priceAnnual}
                  onMonthly={option.onMonthly}
                  onAnnual={option.onAnnual}
                  sections={option.sections}
                  isBundle={option.isBundle}
                  savings={option.savings}
                  note={option.note}
                />
              </div>
            ))}
          </div>
        )}
      </div>

      <div className={styles.TestimonialSectionContainer}>
        <TestimonialSection
          testimonials={[
            {
              quote:
                "Thank you so much. Appreciate all the support during my time at UPS. You made bidding so much easier. An amazing product.",
              name: "Capt. Joe K",
            },
            {
              quote:
                "You guys have a great system! You've already put thousands of dollars into my pocket.",
              name: "Capt. Larry B",
            },
            {
              quote:
                "Nice service...I know how hard you all have worked on this program for us these past few years. Again, thank you all.",
              name: "Capt. Luke P",
            },
            {
              quote:
                "Just a short note to say thanks for you service... it keeps me filled in as to what is going on. Friendly service and instructions.",
              name: "Capt. Mark R",
            },
            {
              quote:
                "With your program, I traded a 15 hour 3 day for a 20 hour 3 day. It made me $600 and I got a notification to alert me. No more checking on the computer!",
              name: "Capt. Norm D",
            },
          ]}
        />
      </div>
      <div className={styles.ClientListContainer}>
        <ClientList
          headerRef={clientListHeaderRef}
          clientRowRef={clientListRowRef}
          scrolled={scrolled}
        />
      </div>
      <div className={styles.FooterListContainer}>
        <Footer lists={footerLists} inverse={false} />
      </div>
      {!userValid && isModalOpen && (
        <AttentionModal
          isOpen={isModalOpen}
          onCloseButtonClick={() => setIsModalOpen(false)}
          airline="UPS"
        />
      )}
    </>
  );
};
